"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POINT_TEMPLATE = exports.POINT_PLACEHOLDER = exports.MULTIPLIER_TEMPLATE = exports.MULTIPLIER_PLACEHOLDER = void 0;
var POINT_TEMPLATE = '%{point_template}';
exports.POINT_TEMPLATE = POINT_TEMPLATE;
var POINT_PLACEHOLDER = '%{point}';
exports.POINT_PLACEHOLDER = POINT_PLACEHOLDER;
var MULTIPLIER_TEMPLATE = '%{multiplier_template}';
exports.MULTIPLIER_TEMPLATE = MULTIPLIER_TEMPLATE;
var MULTIPLIER_PLACEHOLDER = '%{multiplier}';
exports.MULTIPLIER_PLACEHOLDER = MULTIPLIER_PLACEHOLDER;